import { cleanStopName, delayClass, escapeHtml, formatClock, formatDelay } from '../format';
import type { Vehicle } from '../types';

/** Small hover card that follows the cursor over the map. */
export class Tooltip {
  constructor(private readonly root: HTMLElement) {}

  show(vehicle: Vehicle, x: number, y: number): void {
    const line = vehicle.line;
    const target = vehicle.direction ? cleanStopName(vehicle.direction) : 'Unbekanntes Ziel';
    const next = vehicle.nextStop
      ? `${formatClock(vehicle.nextStopTime)} ${cleanStopName(vehicle.nextStop)}`
      : null;

    this.root.innerHTML =
      `<span class="tooltip-line" style="background:${escapeHtml(line.bg)};color:${escapeHtml(
        line.fg,
      )}">${escapeHtml(line.name)}</span>` +
      `<span>${escapeHtml(target)}</span>` +
      `<span class="tooltip-sub">` +
      (next ? `${escapeHtml(next)} · ` : '') +
      `<span class="${delayClass(vehicle.delay)}">${escapeHtml(formatDelay(vehicle.delay))}</span>` +
      `</span>`;

    this.root.hidden = false;
    this.root.style.left = `${x}px`;
    this.root.style.top = `${y - 14}px`;
  }

  hide(): void {
    this.root.hidden = true;
  }
}
